import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorBackground, csColorBorder, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const cscTileConfiguratorWidgetBar = {
  transitionDuration: css`var(--csc-tile-configurator-widget-bar-transition-duration, var(--cs-transition-duration, 0.2s))`,
}

export const style = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .widget-bar {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${csSpacing.spacing07};
    width: 100%;
    box-sizing: border-box;
    padding: ${csSpacing.spacing05} ${csSpacing.spacing06};
  }

  .widget-bar cse-text {
    display: block;
  }

  .widget-bar-group {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    min-width: 0;
  }

  .widget-bar-items {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }

  .widget-item {
    background: ${csColorBackground.primary};
    padding: ${csSpacing.spacing03} ${csSpacing.spacing05};
    border-radius: ${csBorder.radiusMinimal};
    border: ${csBorder.width} solid ${csColorBorder.light};
    cursor: grab;
    text-align: left;
    transition: border-color ${cscTileConfiguratorWidgetBar.transitionDuration} ease, background-color ${cscTileConfiguratorWidgetBar.transitionDuration} ease;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${csSpacing.spacing05};
    width: 100%;
    box-sizing: border-box;
    min-height: 0;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
  }

  .widget-item:hover {
    background: ${csColorBackground.info};
    border-color: ${csColorAction.linkPrimary};
  }

  .widget-item:active {
    cursor: grabbing;
  }

  .widget-item.dragging {
    opacity: 0.5;
  }

  .widget-item cse-icon {
    flex: none;
    font-size: 10px;
    color: ${csColorBorder.light};
  }

  .widget-item > cse-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .widget-item-count {
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 14px;
    height: 14px;
    padding: 0 ${csSpacing.spacing02};
    box-sizing: border-box;
    border-radius: 999px;
    background: ${csColorBorder.medium};
  }

  .widget-item-count cse-text {
    --cse-text-color: ${csColorText.white};
    --cs-font-caption-s-font-size: 10px;
    --cs-font-caption-s-font-size-mobile: 10px;
    --cs-font-caption-s-line-height: 1;
  }

  /* Mobile preview mode — see csc-tile-configurator-widget-bar's mobileMode. Dimmed and
     not-allowed rather than removed entirely, so it's still legible which widgets exist while
     communicating they can't be dragged right now. */
  .widget-bar.disabled .widget-item {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .widget-bar.disabled .widget-item:hover {
    background: ${csColorBackground.primary};
    border-color: ${csColorBorder.light};
  }
`
